module.exports = __webpack_public_path__ + "img/15 Aniamtion 3-squashed.ad8b1d17.jpg";